import React,{Component} from "react";
import "./subscribe.css";
import { SETTINGS_API_URL } from "../../../../store/constants/urls";
import { render } from "react-dom";

export default class Subscribe extends Component {

    state = {
        subscriptionUrl: "https://hrrpnepal.us12.list-manage.com/subscribe/post?u=e625790c6bdf9419f624ca776&id=012c350bc0'",
        subscriptionLoaded: false
      };

      componentDidMount() {
      if  ( !this.state.subscriptionLoaded )
        {
            let url = `${SETTINGS_API_URL}`;
            fetch(url)
            .then(res => res.json())
            .then(data => {
                    this.setState({
                    'subscriptionUrl' : data.data[5]['subscription_url'],
                    'subscriptionLoaded' : true,
                    });
        });
      }
      }
    
    
    render(){
        if (!this.state.subscriptionLoaded){
            return (<div></div>);
        }
        else {
        return (
            <section id="subscribe">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <h3>Subscribe to</h3>
                            <h6 className="text-capitalize">
                                nepal housing recovery and reconstruction media digest
                            </h6>
                            <a href={this.state.subscriptionUrl} target="_blank" className="btn btn-primary ripple">
                                Click to subscribe
                            </a>
                        </div>
                    </div>
                </div>
            </section>
    );
    }
    };
}
